'use strict';

angular.module('integrationModule')

.controller('IntegrationEditCtrl', function ($scope, model)
{
    $scope.model = model;

    $scope.saveModel = function ()
    {
        $scope.model.DSCreate().then(function ()
        {
            $scope.$close(model);
        });
    };
});
